(() => {
  const init = () => {
    document.querySelectorAll('[data-ia-immersive-hero]').forEach(hero => {
      if (hero.dataset.iaMotionReady) return;
      hero.dataset.iaMotionReady = 'true';
      hero.querySelectorAll('[data-ia-hero-line]').forEach((line, index) => {
        line.style.setProperty('--ia-hero-delay', `${400 + index * 320}ms`);
      });
      hero.classList.add('ia-immersive-motion');
    });
  };
  document.addEventListener('shopify:section:load', init);
  init();
})();
